export default {
    "draft": 'draft',
    "unpublished": 'un-published',
    "published": 'published'

}
